import { render } from "./studioCourseXb.vue?vue&type=template&id=6db6d720&scoped=true"
import script from "./studioCourseXb.vue?vue&type=script&lang=js"
export * from "./studioCourseXb.vue?vue&type=script&lang=js"

import "./studioCourseXb.vue?vue&type=style&index=0&id=6db6d720&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db6d720"]])

export default __exports__